<div class="card community-widget" *transloco="let t">
  <div class="card-header d-flex align-items-center justify-content-between">
    <strong>{{ t('community.title') }}</strong>
    <a class="small" [routerLink]="allThreadsLink">{{ t('community.widget.see_all') }} →</a>
  </div>
  <div class="card-body p-0">
    @if (loading()) {
      <div class="text-center py-3 text-muted small">{{ t('community.widget.loading') }}</div>
    } @else if (threads().length === 0) {
      <div class="p-3 text-muted small">{{ t('community.threads.empty') }}</div>
    } @else {
      <ul class="community-widget__list list-unstyled mb-0">
        @for (th of threads(); track th.id) {
          <li [class.community-private-room]="th.channel.private" (contextmenu)="th.channel.private && $event.preventDefault()">
            <div class="community-widget__item d-flex align-items-start gap-2">
              @if (th.unread) {
                <span class="community-widget__dot community-widget__dot--unread"></span>
              } @else if (th.has_unread_replies) {
                <span class="community-widget__dot community-widget__dot--replies"></span>
              }
              <div class="flex-grow-1">
              <a class="community-widget__link d-block text-decoration-none" [routerLink]="threadLink(th.id)">
              <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                @if (th.channel) {
                  <span class="badge bg-info text-dark"># {{ th.channel.name }}</span>
                }
                @if (th.channel.private) {
                  <span class="badge bg-dark">🔐 {{ t('community.private_room.badge') }}</span>
                }
                @if (th.pinned) {
                  <span class="badge bg-warning text-dark">📌 {{ t('community.threads.pinned') }}</span>
                }
                @if (th.locked) {
                  <span class="badge bg-secondary">🔒 {{ t('community.threads.locked') }}</span>
                }
                <strong class="community-widget__title">{{ th.title }}</strong>
              </div>
              @if (th.body) {
                <div class="text-muted small community-widget__preview">
                  {{ stripHtml(th.body) | slice:0:140 }}
                </div>
              }
              </a>
              <div class="small text-muted mt-1">
                @if (th.user; as author) {
                  <a class="community-widget__author" [routerLink]="memberLink(author.id)">{{ author.display_name }}</a>
                } @else {
                  —
                }
                <founding-member-badge compact
                                       [foundingMember]="th.user?.founding_member"
                                       [memberNumber]="th.user?.founding_member_number" />
                <founding-member-badge compact kind="practitioner"
                                       [foundingMember]="th.user?.founding_practitioner"
                                       [memberNumber]="th.user?.founding_practitioner_number" />
                <app-community-badges [badges]="th.user?.badges" />
                · {{ th.created_at | date:'medium' }}
              </div>
              </div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</div>
